import { Component, Input } from '@angular/core'
import { PipelineType } from '../../../shared/model/jobs'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { HttpErrorResponse } from '@angular/common/http'
import { catchError, map, of } from 'rxjs'
import { selectImageLayers } from '../../../state/viewer/viewer.selectors'
import { JobApiService } from '../../../shared/services/job-api.service'
import { ToasterService } from '../../../shared/services/toaster.service'
import { Store } from '@ngrx/store'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-registration-selection',
    templateUrl: './registration-selection.component.html',
    styleUrls: ['./registration-selection.component.scss'],
})
export class RegistrationSelectionComponent {
    @Input()
    siblingDatasets: string[] | never[]

    readonly PipelineTypeEnum = PipelineType
    selectedPipeline = PipelineType.mIHC

    readonly mihcRegistrationSourceLayers$ = this.store.select(selectImageLayers)
    readonly startMihcRegistrationJobFn = (
        targetLayer: string | undefined,
        sourceLayers: (string | undefined)[],
        batch: boolean
    ): void => {
        this.startRegistrationJob(targetLayer, sourceLayers, PipelineType.mIHC, batch)
    }

    readonly cycifRegistrationSourceLayers$ = this.jobApi.getDapiLayers().pipe(
        map(layers =>
            layers.map(layer => ({
                name: layer,
            }))
        ),
        catchError(error => {
            this.toaster.httpError(error, 'Failed to load job configuration options.')
            closeJobSelectionDialog()
            return of([])
        })
    )
    readonly startCycifRegistrationJobFn = (
        targetLayer: string | undefined,
        sourceLayers: (string | undefined)[]
    ): void => {
        this.startRegistrationJob(targetLayer, sourceLayers, PipelineType.cycIF, true)
    }

    private readonly wikiUrl = environment.wikiUrl

    constructor(
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService,
        private readonly store: Store
    ) {}

    private startRegistrationJob(
        targetLayer: string | undefined,
        sourceLayers: (string | undefined)[],
        registrationType: PipelineType.mIHC | PipelineType.cycIF,
        batch: boolean
    ): void {
        this.jobApi
            .startRegistrationJob({
                type: registrationType,
                target: targetLayer,
                source: sourceLayers,
                batch: batch,
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }

    goToWiki(): void {
        window.open(`${this.wikiUrl}home/Working_with_jobs#h-1-registration`, '_blank')
    }
}
